/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Geojson location of AtoN
 * @export
 * @interface AtoNDefinitionPosition
 */
export interface AtoNDefinitionPosition {
    /**
     * 
     * @type {Array<number>}
     * @memberof AtoNDefinitionPosition
     */
    coordinates?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof AtoNDefinitionPosition
     */
    type?: string;
}

/**
 * Check if a given object implements the AtoNDefinitionPosition interface.
 */
export function instanceOfAtoNDefinitionPosition(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AtoNDefinitionPositionFromJSON(json: any): AtoNDefinitionPosition {
    return AtoNDefinitionPositionFromJSONTyped(json, false);
}

export function AtoNDefinitionPositionFromJSONTyped(json: any, ignoreDiscriminator: boolean): AtoNDefinitionPosition {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'coordinates': !exists(json, 'coordinates') ? undefined : json['coordinates'],
        'type': !exists(json, 'type') ? undefined : json['type'],
    };
}

export function AtoNDefinitionPositionToJSON(value?: AtoNDefinitionPosition | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'coordinates': value.coordinates,
        'type': value.type,
    };
}

